import { Outlet } from 'react-router-dom';

import { AppHeader } from './AppHeader';
import { StatusBar } from './StatusBar/StatusBar';
import { Helmet } from 'react-helmet-async';

export const HeaderComponent = () => {
  return (
    <div className="relative scroll-smooth">
      <Helmet>
        <title>NOA</title>
      </Helmet>
      <div className="fixed inset-0 h-16 w-full flex items-center gap-4 z-30">
        <AppHeader />
        <div className="grow">{/* Spacer */}</div>
        <StatusBar />
      </div>
      <div className="w-screen h-screen pt-24">
        <Outlet />
      </div>
    </div>
  );
};
